const getters = {
  currentUrl: state=>state.app.currentUrl,
  areaCodeData: state=>state.app.areaCodeData,
  qiNiuToken: state=>state.app.qiNiuToken,
  classificationFirst: state=>state.app.classificationFirst,
  goodsCategorySysIdFirst: state=>state.app.goodsCategorySysIdFirst,
  goodsCategorySysIdSecond: state=>state.app.goodsCategorySysIdSecond,
  goodsCategorySysIdThird: state=>state.app.goodsCategorySysIdThird,
  Pcoin: state=>state.app.Pcoin,
  h5Config: state=>state.app.h5Config,
  
  
  userInfo: state=>state.my.userInfo,
  friendList: state=>state.my.friendList,
  friendListShow: state=>state.my.friendListShow,
  shopListShow: state=>state.my.shopListShow,
  selectWallet: state=>state.my.selectWallet,
  selectCard: state=>state.my.selectCard,
  withdrawalData: state=>state.my.withdrawalData,
  
  sgOrderType: state=>state.my.sgOrderType,
  addressList: state=>state.my.addressList,
  addressListMap: state=>state.my.addressListMap,
  addressSelectedId: state=>state.my.addressSelectedId,
  
  
  
  mallActive: state=>state.mall.mallActive,
  goodsDetail: state=>state.mall.goodsDetail,
  shopDetail: state=>state.mall.shopDetail,
  liveGoodsDetail: state=>state.mall.liveGoodsDetail,
  shenggouTabsOnTop: state=>state.mall.shenggouTabsOnTop,
  goodsTabsOnTop: state=>state.mall.goodsTabsOnTop,
  
  nim: state=>state.im.nim,
  nimIsLink: state=>state.im.nimIsLink,
  currChatroomMsgs: state=>state.im.currChatroomMsgs,
  noMoreHistoryMsgs: state=>state.im.noMoreHistoryMsgs,
  isSendMsgOK: state=>state.im.isSendMsgOK,
  
  audioSrc: state=>state.audio.audioSrc,
  audioIsPlaying: state=>state.audio.audioIsPlaying,
  remainingTime: state=>state.audio.remainingTime,
  
  videoSrc: state=>state.video.videoSrc,
  
  
  skus: state=>state.sg.skus,
  currentProductId: state=>state.sg.currentProductId,
  skusImgs: state=>state.sg.skusImgs,
  goodsDetails: state=>state.sg.goodsDetails,
  skusStyle: state=>state.sg.skusStyle,
  
  currentSku: state=>state.sg.currentSku,
  currentBuyNum: state=>state.sg.currentBuyNum,
  currentsSelectText: state=>state.sg.currentsSelectText,
  currentSkuStock: state=>state.sg.currentSkuStock,
  currentSalesCheck: state=>state.sg.currentSalesCheck,
  currentUpDownStatus: state=>state.sg.currentUpDownStatus,
  currentIsAreaRestrict: state=>state.sg.currentIsAreaRestrict,
  goodsStock: state=>state.sg.goodsStock,
  currentsFreight: state=>state.sg.currentsFreight,
  currentPrice: state=>state.sg.currentPrice,
  lastAddress: state=>state.sg.lastAddress,
  jdSkuShow: state=>state.sg.jdSkuShow,
  buyCartCount: state=>state.sg.buyCartCount,
  cartList: state=>state.sg.cartList,
  cartEditState: state=>state.sg.cartEditState,
  cartAllSelect: state=>state.sg.cartAllSelect,
  cartEditAllSelect: state=>state.sg.cartEditAllSelect,
  cartShopMap: state=>state.sg.cartShopMap,
  cartGoodsMap: state=>state.sg.cartGoodsMap,
  cartPriceMap: state=>state.sg.cartPriceMap,
  cartTotalPrice: state=>state.sg.cartTotalPrice,
  cartTotalGoodsCount: state=>state.sg.cartTotalGoodsCount,
  
  isAreaRestrictMap: state=>state.sg.isAreaRestrictMap,
  upDownStatusMap: state=>state.sg.upDownStatusMap,
  skusStockMap: state=>state.sg.skusStockMap,
  salesCheckMap: state=>state.sg.salesCheckMap,
  
  
  
  
  
  
  notGoodsList: state=>state.sgOrder.notGoodsList,
  sgOrderGoodsList: state=>state.sgOrder.sgOrderGoodsList,
  calendarListResult: state=>state.sgOrder.calendarListResult,
  laCalendarListResult: state=>state.sgOrder.laCalendarListResult,
  skuClassifyResult: state=>state.sgOrder.skuClassifyResult,
  sgOrderFreight: state=>state.sgOrder.sgOrderFreight,
  sgOrderGoodsCount: state=>state.sgOrder.sgOrderGoodsCount,
  sgOrderTotalPrice: state=>state.sgOrder.sgOrderTotalPrice,
  sgOrderTotalDeductionPrice: state=>state.sgOrder.sgOrderTotalDeductionPrice,
  sgOrderTotalDeductionCoin: state=>state.sgOrder.sgOrderTotalDeductionCoin,
  antWallet: state=>state.sgOrder.antWallet,
  
  
  
 
}
export default getters